import { AutogenModelOrdersLookupAddStatus, AutogenRowOrdersLookupAddStatus } from "./autogen/AutogenModelOrdersLookupAddStatus";

export class ModelOrdersLookupAddStatus extends AutogenModelOrdersLookupAddStatus<RowOrdersLookupAddStatus> {
	constructor() {
		super(RowOrdersLookupAddStatus);
	}
}

export class RowOrdersLookupAddStatus extends AutogenRowOrdersLookupAddStatus {
}